import React from 'react';
import PropTypes from 'prop-types';
import { setNewRelicCustomAttribute } from 'ddc-new-relic';

const VehicleCard = ({
	href,
	imageUrl,
	children,
	imageTitle,
	imageAlt,
	triggerTrackingEvent
}) => {
	const optionalImageAttributes = {};
	if (imageTitle) optionalImageAttributes.title = imageTitle;
	const onClick = () => {
		setNewRelicCustomAttribute('wsSiteTextSearch-onSubmit', 'true');
		setNewRelicCustomAttribute(
			'wsSiteTextSearch-onSubmitSingleVehicleCard',
			'true'
		);
		triggerTrackingEvent({
			element: 'vehicle card',
			elementCTA: 'autocomplete vehicle card',
			result: 'navigated to VDP'
		});
	};
	return (
		<a
			href={href}
			className="vehicle-card-horizontal vehicle-card-mini"
			onClick={onClick}
		>
			<div className="vehicle-card-media-container flex-grow-0">
				<img
					src={`${imageUrl}?impolicy=downsize&w=200`}
					alt={imageAlt}
					{...optionalImageAttributes}
				/>
			</div>
			<div className="vehicle-card-details-container">{children}</div>
		</a>
	);
};
VehicleCard.propTypes = {
	href: PropTypes.string.isRequired,
	imageUrl: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	imageTitle: PropTypes.string,
	imageAlt: PropTypes.string,
	triggerTrackingEvent: PropTypes.func
};
VehicleCard.defaultProps = {
	imageTitle: '',
	imageAlt: '',
	triggerTrackingEvent() {}
};
export default VehicleCard;
